import { DROPDOWN_PAGE, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { SubRegion, SubRegionPayload } from "./types";

/** sub-region — /subRegion */
export const subRegionApi = {
  getAll: () => panelGet<SubRegion[]>("/subRegion", DROPDOWN_PAGE),
  getById: (id: string) => panelGet<SubRegion>(`/subRegion/${id}`),
  /** Sub-regions belonging to one region — drives the Region → Sub Region cascade. */
  byRegion: (regionId: string) => panelGet<SubRegion[]>(`/subRegion/region/${regionId}`),
  create: (payload: SubRegionPayload) => panelPost<SubRegion>("/subRegion", payload),
  update: (id: string, payload: SubRegionPayload) => panelPut<SubRegion>(`/subRegion/${id}`, payload),
  remove: (id: string) => panelDelete(`/subRegion/${id}`),
};
